module.exports = __webpack_public_path__ + "img/South African Airways.7c204d15.png";